import React, { createContext, useEffect, useReducer, useState } from "react";
import { reducer } from "./MenuContextReducers";

const initialState = {
  menus: JSON.parse(localStorage.getItem("menu")) || [],
  role: localStorage.getItem("role"),
};

export const PermissionMenuContext = createContext(initialState);

export default function PermissionBasedMenuProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [userPermissionList, setUserPermissionList] = useState([]);

  // Compute and sync userPermissionList dynamically whenever state.menus changes
  useEffect(() => {
    const permissionsArray = [];
    const menus = state?.menus || [];
    menus.forEach((item) => {
      if (item.permissions) {
        permissionsArray.push(...item.permissions); // push main menu permissions
      }
      if (item.sub_menu) {
        item.sub_menu.forEach((subItem) => {
          if (subItem.permissions) {
            permissionsArray.push(...subItem.permissions); // push sub-menu permissions
          }
        });
      }
    });
    setUserPermissionList(permissionsArray);
  }, [state?.menus]);

  // Synchronize context state with localStorage dynamically (cross-tab via event, same-tab via polling)
  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedMenu = localStorage.getItem("menu");
        const parsedMenu = storedMenu ? JSON.parse(storedMenu) : [];
        if (JSON.stringify(parsedMenu) !== JSON.stringify(state.menus)) {
          dispatch({ type: "Add_Menu", payload: parsedMenu });
        }
      } catch (e) {
        console.error("Error parsing menu from localStorage:", e);
      }

      const storedRole = localStorage.getItem("role");
      if (storedRole !== state.role) {
        dispatch({ type: "Add_Role", payload: storedRole });
      }
    };

    // Listen to storage events (cross-tab sync)
    window.addEventListener("storage", handleStorageChange);

    // Poll to sync same-tab updates immediately
    const intervalId = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, [state.menus, state.role]);

  return (
    <PermissionMenuContext.Provider value={{ state, dispatch, userPermissionList }}>
      {children}
    </PermissionMenuContext.Provider>
  );
}

